// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OkVT","name":"styles_name__3883D","phone":"styles_phone__2ya3o"};